import * as React from 'react';
import { ModalHeader, Modal, ModalFooter, Button } from 'reactstrap';
import { withRouter, RouteComponentProps } from 'react-router-dom';


type ConfirmationModalOptionsProps = RouteComponentProps & {
    isOpen: boolean;
    message: string;
    conversionId: string | undefined;
    onSubmit: () => void;
};


export class ConfirmationModalOptions extends React.Component<ConfirmationModalOptionsProps, {}>{
    constructor(props: ConfirmationModalOptionsProps) {
        super(props)
        this.state = {};
    }

    redirectionToConversionPage(tab: string) {
        if (tab === 'conversions') {
            this.props.history.push({
                pathname: `/conversion`,
            });
        } else {
            this.props.onSubmit();
            this.props.history.push({
                pathname: `/conversion/${this.props.conversionId}/${tab}`,
                state: { tabName: tab }
            });
        }
    }

    public render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalHeader toggle={() => this.redirectionToConversionPage('options')}>{this.props.message}</ModalHeader>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.redirectionToConversionPage('conversions')}>Conversions</Button>
                    <Button color="secondary" onClick={() => this.redirectionToConversionPage('options')}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withRouter(ConfirmationModalOptions);